// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"538328c2","738":"e4af01a5","778":"a2760ab6"}[chunkId] + ".chunk.js";
};